export default __webpack_public_path__ + "static/media/services.2a391f39.svg";